import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
} from '@angular/router';
import { isUndefined } from 'lodash';
import { Observable } from 'rxjs';
import { DialogService } from '../../dialog/dialog.service';
import { NavigationService } from '../../navigation/navigation.service';
import { BannerCanvasTypesEnum } from '../features-data.data';
import { FeaturesDataStore } from '../features-data.store';
import { Features } from '../sub-models/features.model';
import { map } from 'rxjs/operators';

// should only be used as a superclass; this class is not injectable
export class FeatureGuard implements CanActivate {
  constructor(
    protected featuresDataStore: FeaturesDataStore,
    protected navigationService: NavigationService,
    protected dialogService: DialogService
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    throw new Error(
      'should be implemented in subclasses. should call checkFeatureAccess() with proper arguments'
    );
  }

  checkFeatureAccess(
    featureName: string,
    fallbackRoute: string = '/',
    bannerCanvasType?: BannerCanvasTypesEnum,
    checkReadAccess?: boolean,
    preventReadOnlyAccess: boolean = false
  ): Observable<boolean> {
    return this.featuresDataStore.getFeatures().pipe(
      map((features: Features) => {
        if (features.toggles.isAllAccess(featureName)) {
          return true;
        } else {
          const readOnlyAccess =
            checkReadAccess && features.toggles.isReadOnlyAccess(featureName);

          if (
            bannerCanvasType &&
            (features.toggles.isNoAccess(featureName) || readOnlyAccess)
          ) {
            setTimeout(() => {
              this.dialogService.openGrowthDialog(
                bannerCanvasType,
                featureName
              );
            });
          }

          const result: boolean =
            checkReadAccess && !preventReadOnlyAccess ? readOnlyAccess : false;

          if (
            !result &&
            fallbackRoute &&
            isUndefined(this.navigationService.getLastUrl())
          ) {
            this.navigationService.goBack(fallbackRoute);
          }

          return result;
        }
      })
    );
  }
}
